// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserHasNoGroups_wrapper__2L1y1","text":"UserHasNoGroups_text__1HJHa"};